import React, { Component } from 'react';
import firebase from 'firebase';
import { PageHeader, Grid } from 'react-bootstrap';

class Home extends Component {
  render() {
    const { room } = this.props;
    const user = firebase.auth().currentUser;

    return (
      <Grid>
        <div style={{ textAlign: 'center' }}>
          <br />
          <br />
          <img src='/logo.png' style={{ maxWidth: '80%' }} alt='Logo' />
          <PageHeader>
            Welcome in{' '}
            <span style={{ color: '#0eb2ff' }}>#{room.toUpperCase()}</span>
            <p>
              <small>
                Click on your email in the top right corner to switch the room.
              </small>
            </p>
          </PageHeader>
          <a href='https://itunes.apple.com/us/app/angli%C4%8Dtina-today/id1436713454?l=cs&ls=1&mt=8'>
            <img
              alt='Get it on App Store'
              src='/app-store.svg'
              style={{ height: '80px', margin: '10px' }}
            />
          </a>
          <a href='https://play.google.com/store/apps/details?id=cz.uhk.fim.anglictinatoday&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img
              alt='Get it on Google Play'
              src='/google-play.png'
              style={{ height: '80px', margin: '10px' }}
            />
          </a>
        </div>
      </Grid>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js